import React from 'react';

import ProgramCreateDialog from './ProgramCreateDialog';
import ProgramEditDialog from './ProgramEditDialog';


export default function ProgramList(param) {
    const [list, setList] = React.useState([]);
    const [projectId, setProjectId] = React.useState('');
    const [projectName, setProjectName] = React.useState('');
    const [programId, setProgramId] = React.useState('');
    const [uuid, setUuid] = React.useState('');

    // 프로그램 정보에 변경이 있으면 프로젝트 목록 전체 데이터를 다시 내려 받는다.
    function callbackUpdateList(){
        param.callbackUpdateList();
    }
   
    function renderItems() {

        if(JSON.stringify(list) !== JSON.stringify(param.programList)){
            setList(param.programList);
            setProjectId(param.projectId);

        }
        
        if(list.length > 0) {
            return list.map( (value, i) =>
                <tr key={i}>
                    <td className="mailbox-name "><a className="cursor-pointer" data-toggle="modal" data-target="#ProgramEditDialog" onClick={() => setProgramId(value.id)} >{value.name}</a><br/> <font className="text-danger small">> {value.uuid}</font> </td>
                    <td className="" align="center"><b>제공기간</b><br/>{value.durationValue} {value.durationType}</td>
                    <td className="" align="center"><b>가입기준</b><br/>{value.startPoint}</td>
                    <td className="" align="center"><b>판매기간</b><br/>{value.startDate} ~{value.endDate}</td>
                </tr>
             );
        }else{
            if(param.projectId == ''){
                return (
                    <tr>
                       <td className="mailbox-name">프로젝트를 선택하세요.</td>
                   </tr>
               );
            }else{
                return (
                    <tr>
                       <td className="mailbox-name">조회할 프로그램이 없습니다.</td>
                   </tr>
               );
            }
            
        }
        
    }


    React.useEffect(() => {
        setProjectName(param.projectName);
        setProjectId(param.projectId);
        setUuid(param.projectUuid);
    });


    return(
        <div className="col-md-9">
            <div className="card">
                <div className="card-header  contentColor">
                    <h4 className="card-title ">{projectName}</h4> <br/>
                    <div className="card-header-image ">
                        <font className="text-danger float-left small"> > {uuid}</font>
                        <a href="" data-toggle="modal" data-target="#ProgramCreateDialog"  title="새 프로그램 추가" ><i className="fas fa-plus"></i> 새 프로그램 추가 </a>
                    </div>
                </div>
                
                <div className="card-body">
                    <div id="external-events">
                        <div className="card card-primary">
                            <div className="card-body p-0">
                                <div className="list-group">
                                    <div className="table-responsive mailbox-messages">
                                        <table className="table table-hover table-striped table-sm">
                                            <tbody>
                                            {renderItems()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ProgramCreateDialog callbackUpdateList={callbackUpdateList} list={list} projectId={projectId} />
            <ProgramEditDialog callbackUpdateList={callbackUpdateList} list={list}  projectId={projectId} programId={programId}  />
        </div>
    );
}